module.exports = __webpack_public_path__ + "static/green_dragon-acb21f343098834210638849201d0436.jpg";